import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';

const supplierSelector = (state) => state.inventory.supplier;

export const getSupplierListArray = createSelector(
  supplierSelector,
  (state) => state.suppliers
);

export const FILTERS_FORM_NAME = 'search';
export const getFiltersFormValues = getFormValues(FILTERS_FORM_NAME);
